import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { LowerCasePipe, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [
    LowerCasePipe,
    NgTemplateOutlet
  ],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent extends BaseComponent {

  @ContentChild(TemplateRef) additionalContent: TemplateRef<any>;

  @Input() title: string;
  @Input() message: string;
  @Input({ required: true }) type: 'success' | 'error' | 'warning' | 'info';
  @Input() alertStyle: 'one-line' | 'multiple' = 'one-line';
}
